import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Layout from "./pages/Layout";
import About from "./pages/About";
import Home from "./pages/Home";
import Design from "./pages/Design";
import TheVerticlesPage from "./sections/TheVerticlesPage";
import Properties from "./pages/Properties";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="design" element={<Design />} />
          <Route path="properties" element={<Properties />} />
          <Route path="verticles" element={<TheVerticlesPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
    // <div className="App">
    //   <Hero />
    //   <Homepage />
    //   <Footer />
    // </div>
  );
}

export default App;
